import clsx from 'clsx';
import Icon from '~/components/data-display/Icon';
import IconInstitution from '~/icons/icon-building.svg?react';
import IconStore from '~/icons/icon-store.svg?react';
import IconBusinessman from '~/icons/icon-user-business.svg?react';
import IconContractor from '~/icons/icon-user-contractor.svg?react';
import colors from '~/theme/colors.module.scss';
import { IdentityType } from '~/types/company-identity';
import styles from './IdentityTypeThumb.module.scss';

interface IdentityTypeThumbProps {
  value: IdentityType | null;
  className?: string;
  backgroundColor?: string;
}

const IconsMap = new Map([
  [IdentityType.Company, IconStore],
  [IdentityType.Pa, IconInstitution],
  [IdentityType.Person, IconBusinessman],
  [IdentityType.Contractor, IconContractor],
]);

const IdentityTypeThumb: React.FC<IdentityTypeThumbProps> = ({
  value,
  className,
  backgroundColor = colors.colorTeal300,
}) => {
  const IconIdentityType = (value && IconsMap.get(value)) || IconStore;

  return (
    <div className={clsx(styles.iconBackground, className)} style={{ backgroundColor }}>
      <Icon component={IconIdentityType} size="md" />
    </div>
  );
};

export default IdentityTypeThumb;
